// extracted by mini-css-extract-plugin
module.exports = {"module":"village-entity_module__1hBv6","townhouse":"village-entity_townhouse__3DBso","item":"village-entity_item__2t7_q"};